export default __webpack_public_path__ + "static/media/no-products.50db14ae.png";